// Function to get a single URL parameter
export const getUrlParameter = (paramName) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
  };
  
  // Function to get all URL parameters as an object
  export const getAllUrlParameters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of urlParams.entries()) {
      params[key] = value;
    }
    return params;
  };
  
  // Function to check if a URL parameter exists
  export const hasUrlParameter = (paramName) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(paramName);
  };

  // Function to check if we're in lite mode
  export const isLiteMode = () => {
    return window.location.pathname === '/lite';
  };

  // Function to check if we're in activity mode (/activity/*)
  export const isActivityMode = () => {
    return window.location.pathname.startsWith('/activity/');
  };

  export const isFrancoflex = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('source') === 'francoflex' || 
    window.location.hostname.includes('francoflex.com');
  };

  export const isMadameAs = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('source') === 'madameas';
  };

  // Check if anonymous authentication is allowed via URL parameter
  // Used as a secret escape hatch: ?anonymous=true shows the anonymous login button
  export const allowAnonymousAuth = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('anonymous') === 'true';
  };
